import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class FilterLineupsByTeamCombinations extends Component {
    onCheck(isChecked) {
        const {combo} = this.props;

        this.props.dispatch(Action.do('filterLineupsByCheckedTeamsCombo', {combo, isChecked}));
    }

    isButtonDisabled() {
        const {combo} = this.props;

        return !combo.isUsedInLineup();
    }

    isComboChecked() {
        const {combo, filterLineupsByTeamCombinations} = this.props;

        return filterLineupsByTeamCombinations.isComboChecked(combo);
    }

    getClassNames(isComboChecked, isButtonDisabled) {
        const classNames = [];
        classNames.push('search-btn');
        classNames.push(this.props.className || '');

        if (isComboChecked && !isButtonDisabled) {
            classNames.push('active');
        }

        return classNames;
    }

    getTitle(isChecked) {
        return isChecked ? 'Search enabled' : 'Search disabled';
    }

    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isSportMlb() && sportConfig.isGameTypeClassic();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const isComboChecked = this.isComboChecked();
        const isButtonDisabled = this.isButtonDisabled();
        const classNames = this.getClassNames(isComboChecked, isButtonDisabled);
        const title = this.getTitle(isComboChecked);

        return (
            <button
                type="button"
                className={classNames.join(' ')}
                onClick={() => ::this.onCheck(!isComboChecked)}
                title={title}
                disabled={isButtonDisabled}
            >
                {title}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {filterLineupsByTeamCombinations, sportConfig} = state;

    return {
        filterLineupsByTeamCombinations,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(FilterLineupsByTeamCombinations);

export {FilterLineupsByTeamCombinations};
